import React from 'react';
import { ModalWindow } from 'components/modal-window/modal-window';
import { withModalActions } from 'core/hocs';
import { FormattedTag } from 'core/components';

import Button from 'reactstrap/lib/Button';
import PropTypes from 'prop-types';
import { MODAL_IDS } from 'src/constants';
import { IconError } from 'components/icons/icon-notification/icon-error';

const WithdrawalKYCModalUI = ({ closeModal }) => {
  function onCloseButtonClick() {
    closeModal(MODAL_IDS.WITHDRAWAL_KYC);
  }

  return (
    <ModalWindow
      id={MODAL_IDS.WITHDRAWAL_KYC}
      coreProps={{ id: MODAL_IDS.WITHDRAWAL_KYC }}
      bodyClassName="p-2 h-100 bg-dark-2"
      closeButtonClassName="d-none"
      fade
    >
      <div className="h-100 d-flex align-items-center">
        <div className="p-2 text-center">
          <IconError className="mt-1 mb-3" />

          <FormattedTag
            id="withdrawal-modal.verification-required.title"
            tag="h3"
            className="text-center mb-1"
          />
          <FormattedTag
            className="d-block text-gray-20 text-center mb-4"
            id="withdrawal-modal.verification-required.description"
          />

          <div className="text-center">
            <FormattedTag
              id="got-it"
              tag={Button}
              onClick={onCloseButtonClick}
              color="primary"
              type="submit"
              form="withdrawal-form"
              className="text-center"
            />
          </div>
        </div>
      </div>
    </ModalWindow>
  );
};

WithdrawalKYCModalUI.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export const WithdrawalKYCModal = withModalActions(WithdrawalKYCModalUI);
